import styled from 'styled-components';
import Heading from '@atoms/Heading/Heading';
import { rem } from 'polished';
import Config from '@config';
import Modal from '../Modal/Modal';
import { MODAL_NAV_HEIGHT, MODAL_VIEWPORT_MARGIN } from '../Modal/Modal.styles';

export const StyledModal = styled(Modal)`
  overflow: hidden;
`;

// Flex column that gives ScrollShadow a definite height to size against,
// so the header and footer stay fixed while the middle scrolls.
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  // Cap to the space left after the close-icon bar. The definite value is
  // what makes the inner ScrollShadow scroll instead of clipping the footer.
  max-height: calc(100dvh - ${MODAL_NAV_HEIGHT});

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    max-height: calc(100vh - ${MODAL_VIEWPORT_MARGIN} - ${MODAL_NAV_HEIGHT});
  }
`;

export const StyledHeading = styled(Heading)`
  && {
    margin-bottom: ${rem(16)};
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  padding: ${rem(16)};
`;
